"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getWeekDay(daysToSkip) {
    if (daysToSkip === void 0) { daysToSkip = 0; }
    var weekDays = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    var day = new Date();
    day.setDate(day.getDate() + daysToSkip);
    return weekDays[day.getDay()];
}
exports.default = getWeekDay;
//# sourceMappingURL=getWeekDay.js.map